import * as filters from './items'

export default function install (Vue) {
  Object.keys(filters).forEach(name => {
    Vue.filter(name, filters[name])
  })
}
